/**
 * 비밀번호 검증: 8자 이상, 영문·숫자·특수문자 조합 필수
 */
const PASSWORD_REGEX =
  /^(?=.*[a-zA-Z])(?=.*\d)(?=.*[!@#$%^&*()\-_=+\x5B\]{}|;:'",.<>?/]).{8,}$/

export const PASSWORD_VALIDATION_ERROR =
  '비밀번호는 8자 이상, 영문·숫자·특수문자의 조합이어야 합니다'

export function isValidPassword(password: string): boolean {
  return PASSWORD_REGEX.test(password)
}

export function validatePassword(password: string): string | null {
  if (!password) return '비밀번호를 입력해주세요'
  if (password.length < 8) return '비밀번호는 8자 이상이어야 합니다'
  if (!isValidPassword(password)) return PASSWORD_VALIDATION_ERROR
  return null
}
